module.exports = __webpack_public_path__ + "img/MIoT.c32defba.png";